<div class="p-2" style="margin-bottom: 7px;">
  <p-panel [(collapsed)]="infoCollapsed" [toggleable]="true" [styleClass]="infoCollapsed ? 'p-panel-outline-light' : 'p-panel-outline'">
    <ng-template pTemplate="header">
      <div class="flex align-items-center">
        <i class="pi pi-info-circle"></i>
        <p class="ml-2 mb-0" style="margin-top: 1px;">{{'common.information' | transloco}}</p>
      </div>
    </ng-template>

    <div class="px-3 py-2">
      <p [innerHTML]="'info.kpisForm.filteredMeasurementsStep.basic' | transloco" class="inline"></p>
      <p-badge value="1" class="mx-1" severity="success"></p-badge>.
    </div>

    <div class="px-3 py-2">
      <p [innerHTML]="'info.kpisForm.filteredMeasurementsStep.totalElements' | transloco" class="inline"></p>
      <p-badge value="2" class="mx-1" severity="success"></p-badge>.
      <p [innerHTML]="'info.kpisForm.filteredMeasurementsStep.preview' | transloco" class="inline"></p>
      <p-badge value="3" class="mx-1" severity="success"></p-badge>.
    </div>

    <div class="px-3 py-2">
      <p [innerHTML]="'info.kpisForm.filteredMeasurementsStep.disable1' | transloco" class="inline"></p>
      <p-badge value="4" class="mx-1" severity="success"></p-badge>
      <p [innerHTML]="'info.kpisForm.filteredMeasurementsStep.disable2' | transloco" class="inline"></p>.
    </div>

    <div class="measurements-card p-3 mb-3 bg-white" style="border-color: #DEE2E6;">
      <div class="flex justify-content-between align-items-center">
        <div class="flex">
          <p class="mb-0 mr-1">{{'model.deviceMeasurements' | transloco}}:</p>
          <p class="mb-0">
            {{'common.disabled' | transloco}}
          </p>
        </div>
        <div class="flex align-items-center">
          <p-badge value="1" styleClass="mr-2" severity="success"></p-badge>
          <button
            [label]="'common.filter' | transloco"
            pButton
            disabled
            icon="pi pi-sliders-h"
          ></button>
        </div>
      </div>
    </div>

    <div class="measurements-card p-3 bg-white" style="border-color: #DEE2E6;">
      <div class="flex justify-content-between align-items-center">
        <div class="flex">
          <p class="mb-0 mr-1">{{'model.deviceMeasurements' | transloco}}:</p>
          <p class="mb-0 lowercase">
            322 {{'misc.sensorsSelected' | transloco}} <p-badge value="2" styleClass="ml-2" severity="success"></p-badge>
          </p>
        </div>
        <div class="flex align-items-center">
          <p-badge value="4" styleClass="mr-2" severity="success"></p-badge>
          <button
            [label]="'common.disable' | transloco"
            pButton
            disabled
            class="p-button-secondary"
            icon="pi pi-times"
          ></button>
        </div>
      </div>
      <div class="flex flex-column fadein mt-3">
        <div class="grid">
          <div class="col-6">
            <label for="deviceSensorNameDemo">{{'attribute.sensorName' | transloco}}</label>
            <input
              pInputText
              disabled
              value="CURRENT_VALUE"
              id="deviceSensorNameDemo"
              type="text"
              class="w-full mt-2"
            >
          </div>
          <div class="col-6">
            <label for="deviceMeasurementTypeSensorsDemo">{{'model.measurementTypes' | transloco}}</label>
            <p-multiSelect
              [(ngModel)]="demoSensorsSelected"
              [options]="demoSensors"
              disabled
              styleClass="w-full mt-2"
              optionLabel="sensor"
              optionValue="sensor"
              id="deviceMeasurementTypeSensorsDemo"
            ></p-multiSelect>
          </div>
        </div>
        <div class="mt-2 flex justify-content-between">
          <div class="flex align-items-center">
            <button
              [label]="'common.preview' | transloco"
              pButton
              disabled
            ></button>
            <p-badge value="3" styleClass="ml-2" severity="success"></p-badge>
          </div>
          <button
            [label]="'common.clear' | transloco"
            pButton
            disabled
            class="p-button-danger"
          ></button>
        </div>
      </div>

    </div>
  </p-panel>
</div>

<div [class.measurements-card-active]="enabledFilters.deviceMeasurementFilters" class="measurements-card p-3">

  <div class="flex justify-content-between align-items-center">

    <div class="flex">
      <p class="mb-0 font-bold mr-1">{{'model.deviceMeasurements' | transloco}}:</p>
      <p *ngIf="!enabledFilters.deviceMeasurementFilters && !loadingDeviceMeasurements" class="mb-0">
        {{'common.disabled' | transloco}}
      </p>
      <p *ngIf="enabledFilters.deviceMeasurementFilters && !loadingDeviceMeasurements" class="mb-0 lowercase">
        {{totalDeviceMeasurements}} {{'misc.sensorsSelected' | transloco}}
      </p>
      <p-skeleton *ngIf="loadingDeviceMeasurements" width="200px" height="1em" class="mt-1 ml-2 fadein"></p-skeleton>
    </div>

    <button
      [label]="(enabledFilters.deviceMeasurementFilters ? 'common.disable' : 'common.filter') | transloco"
      [icon]="enabledFilters.deviceMeasurementFilters ? 'pi pi-times' : 'pi pi-sliders-h'"
      [ngClass]="{ 'p-button-secondary': enabledFilters.deviceMeasurementFilters }"
      (click)="switchFilters('deviceMeasurementFilters')"
      pButton
    ></button>

  </div>

  <div *ngIf="enabledFilters.deviceMeasurementFilters" class="flex flex-column fadein mt-3">
    <div class="grid">
      <div class="col-6">
        <label for="deviceSensorName">{{'attribute.sensorName' | transloco}}</label>
        <input
          [(ngModel)]="filters.deviceMeasurementFilters.name"
          (ngModelChange)="loadAfterDelay('deviceMeasurementFilters')"
          pInputText
          id="deviceSensorName"
          type="text"
          class="w-full mt-2"
        >
      </div>
      <div class="col-6">
        <label for="deviceMeasurementTypeSensors">{{'model.measurementTypes' | transloco}}</label>
        <p-multiSelect
          [(ngModel)]="filters.deviceMeasurementFilters.measurementTypeSensors"
          [options]="measurementTypes"
          (ngModelChange)="loadAfterDelay('deviceMeasurementFilters')"
          styleClass="w-full mt-2"
          optionLabel="sensor"
          optionValue="sensor"
          id="deviceMeasurementTypeSensors"
        ></p-multiSelect>
      </div>
    </div>
    <div class="mt-2 flex justify-content-between">
      <button
        [disabled]="loadingDeviceMeasurements"
        [label]="'common.preview' | transloco"
        (click)="deviceMeasurementsPreviewVisible = true"
        pButton
      ></button>
      <button
        [disabled]="loadingDeviceMeasurements"
        [label]="'common.clear' | transloco"
        (click)="onClearDeviceMeasurementFilters()"
        pButton
        class="p-button-danger"
      ></button>
    </div>
  </div>

</div>

<div [class.measurements-card-active]="enabledFilters.assetMeasurementFilters" class="measurements-card p-3 mt-3">
  <div class="flex justify-content-between align-items-center">
    <div class="flex">
      <p class="mb-0 font-bold mr-1">{{'model.assetMeasurements' | transloco}}:</p>
      <p *ngIf="!enabledFilters.assetMeasurementFilters && !loadingAssetMeasurements" class="mb-0">
        {{'common.disabled' | transloco}}
      </p>
      <p *ngIf="enabledFilters.assetMeasurementFilters && !loadingAssetMeasurements" class="mb-0 lowercase">
        {{totalAssetMeasurements}} {{'misc.sensorsSelected' | transloco}}
      </p>
      <p-skeleton *ngIf="loadingAssetMeasurements" width="200px" height="1em" class="mt-1 ml-2 fadein"></p-skeleton>
    </div>
    <button
      [label]="(enabledFilters.assetMeasurementFilters ? 'common.disable' : 'common.filter') | transloco"
      [icon]="enabledFilters.assetMeasurementFilters ? 'pi pi-times' : 'pi pi-sliders-h'"
      [ngClass]="{ 'p-button-secondary': enabledFilters.assetMeasurementFilters }"
      (click)="switchFilters('assetMeasurementFilters')"
      pButton
    ></button>
  </div>
  <div *ngIf="enabledFilters.assetMeasurementFilters" class="flex flex-column fadein mt-3">
    <div class="grid">
      <div class="col-6">
        <label for="assetSensorName">{{'attribute.sensorName' | transloco}}</label>
        <input
          [(ngModel)]="filters.assetMeasurementFilters.name"
          (ngModelChange)="loadAfterDelay('assetMeasurementFilters')"
          pInputText
          id="assetSensorName"
          type="text"
          class="w-full mt-2"
        >
      </div>
      <div class="col-6">
        <label for="assetMeasurementTypeSensors">{{'model.measurementTypes' | transloco}}</label>
        <p-multiSelect
          [(ngModel)]="filters.assetMeasurementFilters.measurementTypeSensors"
          [options]="measurementTypes"
          (ngModelChange)="loadAfterDelay('assetMeasurementFilters')"
          styleClass="w-full mt-2"
          optionLabel="sensor"
          optionValue="sensor"
          id="assetMeasurementTypeSensors"
        ></p-multiSelect>
      </div>
    </div>
    <div class="mt-2 flex justify-content-between">
      <button
        [disabled]="loadingAssetMeasurements"
        [label]="'common.preview' | transloco"
        (click)="assetMeasurementsPreviewVisible = true"
        pButton
      ></button>
      <button
        [disabled]="loadingAssetMeasurements"
        [label]="'common.clear' | transloco"
        (click)="onClearAssetMeasurementFilters()"
        pButton
        class="p-button-danger"
      ></button>
    </div>
  </div>
</div>

<div [class.measurements-card-active]="enabledFilters.kpiFilters" class="measurements-card p-3 mt-3 mb-3">
  <div class="flex justify-content-between align-items-center">
    <div class="flex">
      <p class="mb-0 font-bold mr-1">{{'model.kpis' | transloco}}:</p>
      <p *ngIf="!enabledFilters.kpiFilters && !loadingKpis" class="mb-0">
        {{'common.disabled' | transloco}}
      </p>
      <p *ngIf="enabledFilters.kpiFilters && !loadingKpis" class="mb-0 lowercase">
        {{totalKpis}} {{'misc.kpisSelected' | transloco}}
      </p>
      <p-skeleton *ngIf="loadingKpis" width="200px" height="1em" class="mt-1 ml-2 fadein"></p-skeleton>
    </div>
    <button
      [label]="(enabledFilters.kpiFilters ? 'common.disable' : 'common.filter') | transloco"
      [icon]="enabledFilters.kpiFilters ? 'pi pi-times' : 'pi pi-sliders-h'"
      [ngClass]="{ 'p-button-secondary': enabledFilters.kpiFilters }"
      (click)="switchFilters('kpiFilters')"
      pButton
    ></button>
  </div>
  <div *ngIf="enabledFilters.kpiFilters" class="flex flex-column fadein mt-3">
    <div class="grid">
      <div class="col-12">
        <label for="kpiName">{{'attribute.name' | transloco}}</label>
        <input
          [(ngModel)]="filters.kpiFilters.name"
          (ngModelChange)="loadAfterDelay('kpiFilters')"
          pInputText
          id="kpiName"
          type="text"
          class="w-full mt-2"
        >
      </div>
    </div>
    <div class="mt-2 flex justify-content-between">
      <button
        [disabled]="loadingKpis"
        [label]="'common.preview' | transloco"
        (click)="kpisPreviewVisible = true"
        pButton
      ></button>
      <button
        [disabled]="loadingKpis"
        [label]="'common.clear' | transloco"
        (click)="onClearKpiFilters()"
        pButton
        class="p-button-danger"
      ></button>
    </div>
  </div>
</div>

<p-dialog
  *ngIf="enabledFilters.deviceMeasurementFilters"
  [(visible)]="deviceMeasurementsPreviewVisible"
  [breakpoints]="{'1200px': '90vw', '576px': '100vw'}"
  [style]="{width: '75vw'}"
  [header]="'model.devices' | transloco"
  [modal]="true"
  [draggable]="false"
>
  <p-table
    [(first)]="deviceMeasurementsFirst"
    [(rows)]="deviceMeasurementsRows"
    [value]="deviceMeasurements"
    [totalRecords]="totalDeviceMeasurements"
    [lazy]="true"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    (onLazyLoad)="deviceMeasurementsPreviewVisible ? onApplyDeviceMeasurementFilters($event) : ''"
    styleClass="p-datatable-striped"
    sortField="name"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="w-18rem" pSortableColumn="device.serialNumber">
          {{'model.device' | transloco}}
          <p-sortIcon field="device.serialNumber"></p-sortIcon>
        </th>
        <th class="w-18rem" pSortableColumn="name">
          {{'model.sensor' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="measurementType.sensor">
          {{'model.sensorType' | transloco}}
          <p-sortIcon field="measurementType.sensor"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-measurement>
      <tr *ngIf="!loadingDeviceMeasurements">
        <td>
          <span class="p-column-title bold">{{'model.device' | transloco}}</span>
          {{measurement.device.serialNumber}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
          <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
          {{measurement.description}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
          {{measurement.measurementType?.sensor ?? ''}}
        </td>
      </tr>
      <tr *ngIf="loadingDeviceMeasurements" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between" *ngIf="totalDeviceMeasurements == 0">
        {{'pagination.empty' | transloco}}
      </div>
      <div class="flex align-items-center justify-content-between" *ngIf="totalDeviceMeasurements > 0">
        {{'pagination.showing' | transloco}} {{deviceMeasurementsFirst + 1}}
        {{'pagination.to' | transloco}} {{
        (deviceMeasurementsFirst + deviceMeasurementsRows) >= totalDeviceMeasurements ?
          (totalDeviceMeasurements) :
          (deviceMeasurementsFirst + deviceMeasurementsRows)
        }}
        {{'pagination.of' | transloco}} {{totalDeviceMeasurements}}
        {{(totalDeviceMeasurements > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
      </div>
    </ng-template>
  </p-table>
</p-dialog>

<p-dialog
  *ngIf="enabledFilters.assetMeasurementFilters"
  [(visible)]="assetMeasurementsPreviewVisible"
  [breakpoints]="{'1200px': '90vw', '576px': '100vw'}"
  [style]="{width: '75vw'}"
  [header]="'model.assets' | transloco"
  [modal]="true"
  [draggable]="false"
>
  <p-table
    [(first)]="assetMeasurementsFirst"
    [(rows)]="assetMeasurementsRows"
    [value]="assetMeasurements"
    [totalRecords]="totalAssetMeasurements"
    [lazy]="true"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    (onLazyLoad)="assetMeasurementsPreviewVisible ? onApplyAssetMeasurementFilters($event) : ''"
    styleClass="p-datatable-striped"
    sortField="name"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="w-18rem" pSortableColumn="asset.alias">
          {{'model.asset' | transloco}}
          <p-sortIcon field="asset.alias"></p-sortIcon>
        </th>
        <th class="w-18rem" pSortableColumn="name">
          {{'model.sensor' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="measurementType.sensor">
          {{'model.sensorType' | transloco}}
          <p-sortIcon field="measurementType.sensor"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-measurement>
      <tr *ngIf="!loadingAssetMeasurements">
        <td>
          <span class="p-column-title bold">{{'model.asset' | transloco}}</span>
          {{measurement.asset.alias}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
          <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
          {{measurement.description}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
          {{measurement.measurementType?.sensor ?? ''}}
        </td>
      </tr>
      <tr *ngIf="loadingAssetMeasurements" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between" *ngIf="totalAssetMeasurements == 0">
        {{'pagination.empty' | transloco}}
      </div>
      <div class="flex align-items-center justify-content-between" *ngIf="totalAssetMeasurements > 0">
        {{'pagination.showing' | transloco}} {{assetMeasurementsFirst + 1}}
        {{'pagination.to' | transloco}} {{
        (assetMeasurementsFirst + assetMeasurementsRows) >= totalAssetMeasurements ?
          (totalAssetMeasurements) :
          (assetMeasurementsFirst + assetMeasurementsRows)
        }}
        {{'pagination.of' | transloco}} {{totalAssetMeasurements}}
        {{(totalAssetMeasurements > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
      </div>
    </ng-template>
  </p-table>
</p-dialog>

<p-dialog
  *ngIf="enabledFilters.kpiFilters"
  [(visible)]="kpisPreviewVisible"
  [breakpoints]="{'1200px': '90vw', '576px': '100vw'}"
  [style]="{width: '75vw'}"
  [header]="'model.kpis' | transloco"
  [modal]="true"
  [draggable]="false"
>
  <p-table
    [(first)]="kpisFirst"
    [(rows)]="kpisRows"
    [value]="kpis"
    [totalRecords]="totalKpis"
    [lazy]="true"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    (onLazyLoad)="kpisPreviewVisible ? onApplyKpiFilters($event) : ''"
    styleClass="p-datatable-striped"
    sortField="name"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          {{'attribute.name' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="timePeriod">
          {{'attribute.timePeriod' | transloco}}
          <p-sortIcon field="timePeriod"></p-sortIcon>
        </th>
        <th pSortableColumn="operation">
          {{'attribute.operation' | transloco}}
          <p-sortIcon field="operation"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-kpi>
      <tr *ngIf="!loadingKpis" class="fadein">
        <td>
          <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
          <p class="text-right md:text-left">{{kpi.name}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
          <p class="text-right md:text-left">{{kpi.description}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.timePeriod' | transloco}}</span>
          <p class="text-right md:text-left">{{kpi.timePeriod}}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{'attribute.operation' | transloco}}</span>
          <p class="text-right md:text-left">{{kpi.operation}}</p>
        </td>
      </tr>
      <tr *ngIf="loadingKpis" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
        <td [style.height]="'39px'"><p-skeleton height="1em"></p-skeleton></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between" *ngIf="totalKpis == 0">
        {{'pagination.empty' | transloco}}
      </div>
      <div class="flex align-items-center justify-content-between" *ngIf="totalKpis > 0">
        {{'pagination.showing' | transloco}} {{kpisFirst + 1}}
        {{'pagination.to' | transloco}} {{
        (kpisFirst + kpisRows) >= totalKpis ?
          (totalKpis) :
          (kpisFirst + kpisRows)
        }}
        {{'pagination.of' | transloco}} {{totalKpis}}
        {{(totalKpis > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
      </div>
    </ng-template>
  </p-table>
</p-dialog>
